import { IResponseCertificationList, IResponseCertificationDetail, IWaysToLearnInfo } from '@/interface/certification'
import { PracticalItem, IBannerListItem } from '@/interface'
const state = {
  // 数据是否加载完成
  loaded: false,
  certificationList: [] as any[],
  list: {} as IResponseCertificationList,
  detail: {} as IResponseCertificationDetail,
  bannerList: [] as IBannerListItem[],
  practicalExamDetail: {} as PracticalItem,
  waysToLearnInfo: [] as IWaysToLearnInfo[]
}

export type CertificationState = typeof state

const certificationStore = {
  namespaced: true,
  state,
  mutations: {
    setCertificationList (state: CertificationState, data = [] as any[]): void {
      state.certificationList = data
    },
    setCertificationDetail (state: CertificationState, data = {} as IResponseCertificationDetail): void {
      state.detail = data
      state.loaded = true
    },
    setLoaded (state: CertificationState, bool: boolean) {
      state.loaded = bool
    },
    setWaysToLearnInfo (state: CertificationState, waysToLearnInfo: IWaysToLearnInfo[]) {
      state.waysToLearnInfo = waysToLearnInfo
    },
    setPracticalExamDetail (state: CertificationState, data: PracticalItem) {
      state.practicalExamDetail = data
    },
    setBannerList (state: CertificationState, data: IBannerListItem[]) {
      state.bannerList = data
    }
  }
}

export {
  certificationStore
}
